import * as React from "react";
const ThemeContext = React.createContext<[string, (theme: string) => void]>([
  "dark",
  (theme: string) => {
    // do nothing
  },
]);

export default ThemeContext;
